module.exports = __webpack_public_path__ + "media/images/ready-to-submit-73dc808cc59c246c8a2d2d4b8074a7bd.jpg";